
export default 'ivu-date-picker-cells';


// WEBPACK FOOTER //
// ./src/components/common/datePicker/base/prefixCls.js